import { Component, Host, h, Prop } from "@stencil/core";
import { state } from "../stores/notification-handler-store";

@Component({
    tag: "uxn-notification-bell",
    styleUrl: "notification-bell.scss",
    shadow: false,
})
export class NotificationBell {
    private baseClass: string = "uxn-notification-bell";

    /** environment for fetching data  */
    @Prop() env: string = "prod";

    /** debugging */
    @Prop() debug: boolean = true;

    render() {
        return (
            <Host class={this.baseClass}>
                <div class="uxn-notification-bell__content">
                    {state.get("token") !== null && state.get("counter") > 0 ? (
                        <ux-notification-bell counter={state.get("counter")} />
                    ) : (
                        <ux-notification-bell />
                    )}
                </div>
            </Host>
        );
    }
}
